// Application release version — single source of truth for the client.
// Must match the root VERSION file, package.json files and the release ZIP
// / commit message for each delivery.
export const APP_VERSION = '0.9.0.40';
